var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.swiperList && _vm.swiperList.length == 10 ? 'brand-list-block' : 'about-list-block'},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-slide"},_vm._l((_vm.swiperList),function(item,idx){return _c('a',{key:idx},[_c('img',{attrs:{"src":item}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }